"use client";

import { c as _c } from "react/compiler-runtime";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/constants/queryKeys";
import api from "@/actions/api";
import { Query } from "@/types/queryTpes";
import { LocationSearchResult } from "@/types/locations";
import { SearchTypes } from "@/constants/filters";
type Props = {
  enabled?: boolean;
  locations: string[];
  businessType?: SearchTypes;
  realEstateType?: number;
  // Full active filters (search page) so the count matches the list.
  filterParams?: URLSearchParams;
};
export const LOCATIONS_BY_ID_QUERY_KEYS = {
  all: [QueryKeys.LOCATIONS_BY_ID],
  byLocations: ({
    locations,
    businessType,
    realEstateType,
    filterParams
  }: {
    locations: string[];
    businessType?: SearchTypes;
    realEstateType?: number;
    filterParams?: URLSearchParams;
  }) => [...LOCATIONS_BY_ID_QUERY_KEYS.all, [...locations].sort().join(","), filterParams ? filterParams.toString() : `${businessType}:${realEstateType}`]
};
export function getLocationsByIdOptions({
  locations,
  businessType,
  realEstateType,
  filterParams
}: {
  locations: string[];
  businessType?: SearchTypes | undefined;
  realEstateType?: number;
  filterParams?: URLSearchParams;
}) {
  const sanitizedRealEstateType = Number.isFinite(realEstateType) ? realEstateType : undefined;
  return queryOptions({
    queryKey: LOCATIONS_BY_ID_QUERY_KEYS.byLocations({
      locations,
      businessType,
      realEstateType: sanitizedRealEstateType,
      filterParams
    }),
    queryFn: () => api.locations.getLocationsById({
      value: [...locations].sort().join(","),
      businessType,
      realEstateType: sanitizedRealEstateType,
      filterParams
    })
  });
}
export function useLocationsById(t0) {
  const $ = _c(8);
  const {
    enabled: t1,
    locations,
    businessType,
    realEstateType,
    filterParams
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== businessType || $[1] !== filterParams || $[2] !== locations || $[3] !== realEstateType) {
    t2 = getLocationsByIdOptions({
      locations,
      businessType,
      realEstateType,
      filterParams
    });
    $[0] = businessType;
    $[1] = filterParams;
    $[2] = locations;
    $[3] = realEstateType;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = enabled && locations.length > 0;
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      ...t2,
      enabled: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
}